import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_buefy_1d6e92c2 from 'nuxt_plugin_buefy_1d6e92c2' // Source: ./buefy.js (mode: 'all')
import nuxt_plugin_pluginutils_11540aea from 'nuxt_plugin_pluginutils_11540aea' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_7b04f496 from 'nuxt_plugin_pluginrouting_7b04f496' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_51b749da from 'nuxt_plugin_pluginmain_51b749da' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_46defaf2 from 'nuxt_plugin_gtm_46defaf2' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_5b8f9371 from 'nuxt_plugin_axios_5b8f9371' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vuescrollto_261ce178 from 'nuxt_plugin_vuescrollto_261ce178' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_image_4696906c from 'nuxt_plugin_image_4696906c' // Source: ./image.js (mode: 'all')
import nuxt_plugin_pluginserver_63f439aa from 'nuxt_plugin_pluginserver_63f439aa' // Source: ./color-mode/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_684c71a3 from 'nuxt_plugin_pluginclient_684c71a3' // Source: ./color-mode/plugin.client.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_10039dce from 'nuxt_plugin_cookieuniversalnuxt_10039dce' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_googleanalytics_3f9037d6 from 'nuxt_plugin_googleanalytics_3f9037d6' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_fontLoader_0a1175c5 from 'nuxt_plugin_fontLoader_0a1175c5' // Source: ./fontLoader.js (mode: 'client')
import nuxt_plugin_axios_54e49ad0 from 'nuxt_plugin_axios_54e49ad0' // Source: ../src/plugins/axios.js (mode: 'client')
import nuxt_plugin_crypto_34a480c2 from 'nuxt_plugin_crypto_34a480c2' // Source: ../src/plugins/crypto.js (mode: 'client')
import nuxt_plugin_localStorage_0afba2b0 from 'nuxt_plugin_localStorage_0afba2b0' // Source: ../src/plugins/localStorage.js (mode: 'client')
import nuxt_plugin_addToCalendarBtn_078f13de from 'nuxt_plugin_addToCalendarBtn_078f13de' // Source: ../src/plugins/addToCalendarBtn.js (mode: 'client')
import nuxt_plugin_qrcodevue_3f3aa2cc from 'nuxt_plugin_qrcodevue_3f3aa2cc' // Source: ../src/plugins/qrcode.vue.js (mode: 'client')
import nuxt_plugin_qrcodereader_a3f99c62 from 'nuxt_plugin_qrcodereader_a3f99c62' // Source: ../src/plugins/qrcodereader.js (mode: 'client')
import nuxt_plugin_anime_7726544c from 'nuxt_plugin_anime_7726544c' // Source: ../src/plugins/anime.js (mode: 'client')
import nuxt_plugin_aos_78ed1f2e from 'nuxt_plugin_aos_78ed1f2e' // Source: ../src/plugins/aos.js (mode: 'client')
import nuxt_plugin_buefy_d1269c2e from 'nuxt_plugin_buefy_d1269c2e' // Source: ../src/plugins/buefy.js (mode: 'all')
import nuxt_plugin_videoPlayer_d0dc9e5c from 'nuxt_plugin_videoPlayer_d0dc9e5c' // Source: ../src/plugins/videoPlayer.js (mode: 'client')
import nuxt_plugin_vime_0be41256 from 'nuxt_plugin_vime_0be41256' // Source: ../src/plugins/vime.js (mode: 'client')
import nuxt_plugin_twitchPlayer_7453a42c from 'nuxt_plugin_twitchPlayer_7453a42c' // Source: ../src/plugins/twitchPlayer.js (mode: 'client')
import nuxt_plugin_tdfp_f148be74 from 'nuxt_plugin_tdfp_f148be74' // Source: ../src/plugins/tdfp.js (mode: 'client')
import nuxt_plugin_globalAnimations_157d2a0e from 'nuxt_plugin_globalAnimations_157d2a0e' // Source: ../src/plugins/globalAnimations.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"TEMPIO DEL FUTURO *PERDUTO","meta":[{"charset":"utf-8"},{"name":"viewport","content":"viewport-fit=cover,width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"},{"hid":"title","name":"title","content":"TEMPIO DEL FUTURO *PERDUTO"},{"name":"probely-verification","content":"783422fa-388f-4839-beab-6eacf45ef5b5"},{"hid":"description","name":"description","content":"Tempio Del Futuro *Perduto is a multifunctional cultural center, a place of sharing and solidarity, experimentation and artistic research."},{"name":"theme-color","content":"#191620"},{"name":"apple-touch-startup-image","content":"\u002Ficons\u002Fpublic\u002Fios\u002F1024.png"},{"name":"apple-mobile-web-app-status-bar-style","media":"(prefers-color-scheme: light)","content":"#191620"},{"name":"apple-mobile-web-app-status-bar-style","media":"(prefers-color-scheme: dark)","content":"#191620"},{"name":"mobile-web-app-capable","content":"yes"}],"link":[{"rel":"stylesheet","href":"https:\u002F\u002Fapi.mapbox.com\u002Fmapbox-gl-js\u002Fv2.3.1\u002Fmapbox-gl.css","crossorigin":"crossorigin"},{"rel":"stylesheet","href":"\u002Ffonts.css"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ficons\u002Ffavicon.ico"},{"rel":"apple-touch-icon","type":"image\u002Fx-icon","sizes":"512x512","href":"icons\u002Fpublic\u002Fios\u002F512.png"},{"rel":"apple-touch-icon","type":"image\u002Fx-icon","sizes":"256x256","href":"icons\u002Fpublic\u002Fios\u002F256.png"},{"rel":"apple-touch-icon","type":"image\u002Fx-icon","sizes":"1024x1024","href":"icons\u002Fpublic\u002Fios\u002F1024.png"},{"name":"msapplication-TileColor","content":"#191620"},{"type":"text\u002Fcss","href":"https:\u002F\u002Fuse.fontawesome.com\u002Freleases\u002Fv5.15.4\u002Fcss\u002Fall.css","rel":"preload","as":"style","onload":"this.rel='stylesheet'"},{"hid":"font-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"font-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"font-preload","rel":"preload","as":"style","href":"\u002Ffonts.css"}],"script":[{"src":"https:\u002F\u002Fapp.termly.io\u002Fresource-blocker\u002F4cbe14a8-ce6c-4122-bd85-c25bae5ef93e?autoBlock=on","type":"text\u002Fjavascript"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-NVGS94Q')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-NVGS94Q&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"},{"hid":"font-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"\u002Ffonts.css\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"],"font-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_buefy_1d6e92c2 === 'function') {
    await nuxt_plugin_buefy_1d6e92c2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_11540aea === 'function') {
    await nuxt_plugin_pluginutils_11540aea(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_7b04f496 === 'function') {
    await nuxt_plugin_pluginrouting_7b04f496(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_51b749da === 'function') {
    await nuxt_plugin_pluginmain_51b749da(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_46defaf2 === 'function') {
    await nuxt_plugin_gtm_46defaf2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5b8f9371 === 'function') {
    await nuxt_plugin_axios_5b8f9371(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_261ce178 === 'function') {
    await nuxt_plugin_vuescrollto_261ce178(app.context, inject)
  }

  if (typeof nuxt_plugin_image_4696906c === 'function') {
    await nuxt_plugin_image_4696906c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_63f439aa === 'function') {
    await nuxt_plugin_pluginserver_63f439aa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_684c71a3 === 'function') {
    await nuxt_plugin_pluginclient_684c71a3(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_10039dce === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_10039dce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_3f9037d6 === 'function') {
    await nuxt_plugin_googleanalytics_3f9037d6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fontLoader_0a1175c5 === 'function') {
    await nuxt_plugin_fontLoader_0a1175c5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_54e49ad0 === 'function') {
    await nuxt_plugin_axios_54e49ad0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_crypto_34a480c2 === 'function') {
    await nuxt_plugin_crypto_34a480c2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localStorage_0afba2b0 === 'function') {
    await nuxt_plugin_localStorage_0afba2b0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_addToCalendarBtn_078f13de === 'function') {
    await nuxt_plugin_addToCalendarBtn_078f13de(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_qrcodevue_3f3aa2cc === 'function') {
    await nuxt_plugin_qrcodevue_3f3aa2cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_qrcodereader_a3f99c62 === 'function') {
    await nuxt_plugin_qrcodereader_a3f99c62(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_anime_7726544c === 'function') {
    await nuxt_plugin_anime_7726544c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aos_78ed1f2e === 'function') {
    await nuxt_plugin_aos_78ed1f2e(app.context, inject)
  }

  if (typeof nuxt_plugin_buefy_d1269c2e === 'function') {
    await nuxt_plugin_buefy_d1269c2e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_videoPlayer_d0dc9e5c === 'function') {
    await nuxt_plugin_videoPlayer_d0dc9e5c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vime_0be41256 === 'function') {
    await nuxt_plugin_vime_0be41256(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_twitchPlayer_7453a42c === 'function') {
    await nuxt_plugin_twitchPlayer_7453a42c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tdfp_f148be74 === 'function') {
    await nuxt_plugin_tdfp_f148be74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globalAnimations_157d2a0e === 'function') {
    await nuxt_plugin_globalAnimations_157d2a0e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
